import { Component, OnInit, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { takeUntil, filter } from 'rxjs/operators';
import { AnimationService } from 'src/app/engine/animation.service';
import { TimerangeModel } from 'src/app/engine/models/animation/timerange.model';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ViewService } from '../../view.service';
import { MediaEnum } from 'src/app/story/models/media.enum';
import { ViewUI } from '../../models/view-ui.enum';
import { ViewUIService } from '../../view-ui.service';
import { ViewState } from '../../state/view.state';
import { SetPlaybackSpeed } from 'src/app/engine/state/engine.actions';

@Component({
  selector: 'app-view-media-bar',
  templateUrl: './view-media-bar.component.html',
  styleUrls: ['./view-media-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewMediaBarComponent implements OnInit, OnDestroy {
  viewLayout = ViewUI;


  // ---------- Selectors ----------
  @Select(EngineState.getAnimationPlaying)
  animationPlaying$: Observable<boolean>;

  @Select(StoryChaptersState.getSelectedChapterId)
  selectedChapterId$: Observable<string>;
  
  @Select(EngineState.getPlayAudio)
  playAudio$: Observable<boolean>;

  @Select(EngineState.getPlaybackSpeed)
  playbackSpeed$: Observable<number>;

  
  // ---------- Input / Output ----------  
  @Input()
  public get template(): MediaEnum {
    return this._template;
  }
  public set template(value: MediaEnum) {
    this._template = value;
    this.updateLayoutProperties(this.template);
  }
  private _template: MediaEnum;

  @Input()
  size: 'small' | 'medium' = 'small';
  

  
  // ---------- Class Properties ----------
  showPlayPause = true;
  showScrubber = true;
  showBar = true;
  audioVisible = false;

  ngUnsubscribe = new Subject();
  timerange: TimerangeModel;
  

  
  // ---------- Lifecycle ----------
  constructor(
    private animationService: AnimationService,
    private viewService: ViewService,
    private layoutService: ViewUIService,
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initChapterListener();
    this.initLayoutListener();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  

  
  // ---------- Event Handling ----------
  initChapterListener() {
    this.selectedChapterId$.pipe(
      filter(chapterId => chapterId != null),
      takeUntil(this.ngUnsubscribe)
    ).subscribe((chapterId) => {
      this.timerange = this.animationService.getChapterLocalTimerange(chapterId);
    });
  }

  initLayoutListener() {
    this.store
      .select(ViewState.getUI)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.audioVisible = this.layoutService.isVisible(ViewUI.Audio);
        this.changeDetectorRef.markForCheck();
      });
  }

  updateLayoutProperties(controls: MediaEnum) {
    this.showBar = controls !== MediaEnum.None;
    this.showScrubber = controls === MediaEnum.Full;
    this.showPlayPause = controls !== MediaEnum.None;
  }

  handlePlayClick() {
    this.viewService.toggleAnimation();
  }

  handleAudioClick() {
    this.viewService.toggleAudio();
  }

  handlePlayChapterFromStartClick() {
    this.viewService.playChapterFromStart();
  }

  setPlaybackSpeed(speed: number) {
    this.store.dispatch(new SetPlaybackSpeed(speed));
  }
}
